import { KTCard } from '../../../_dashboard/helpers'
import MenuNavigationManagement from './MenuNavigationManagement'

const HeaderListWrapper = () => (
  <KTCard>
    <MenuNavigationManagement />
  </KTCard>
)

export { HeaderListWrapper }
